import { HStack, Text, VStack } from "@chakra-ui/react";

const AnswerValue = ({ item }) => {
    const original = item.original_value;
    const hasOriginal = original != null && original !== "" && original !== item.value;

    if (!hasOriginal) {
        return <Text color="gray.900" fontSize="sm" fontWeight={500}>{item.value}</Text>;
    }

    return (
        <VStack align="stretch" gap={1}>
            <Text color="gray.900" fontSize="sm" fontWeight={500}>{original}</Text>
            <HStack gap={1.5} align="flex-start">
                <Text
                    as="span" flexShrink={0} px={1} bg="gray.100" color="gray.500"
                    borderRadius={4} fontSize="2xs" fontWeight={600} lineHeight="18px"
                >
                    PL
                </Text>
                <Text color="gray.500" fontSize="xs" lineHeight="18px">{item.value}</Text>
            </HStack>
        </VStack>
    );
};

export default AnswerValue;
